/*
 * HairPlan motion — minimal, opt-out, no dependencies.
 *
 * Design rules this enforces:
 *  - Nothing is hidden unless motion is actually going to run. The .hp-motion
 *    class is only added when JS runs AND the user has not asked for reduced
 *    motion, so a JS failure or reduced-motion setting can never hide content.
 *  - Reveal happens on intersection, once, then the observer is released.
 *  - Reading and purchasing are never delayed: the hero reveals immediately,
 *    and every reveal is a fade plus <20px of travel.
 */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce && reduce.matches) return;              // leave everything visible
  if (!('IntersectionObserver' in window)) return;   // no polyfill, no hiding

  var root = document.documentElement;
  root.classList.add('hp-motion');

  function setup() {
    var items = document.querySelectorAll('[data-hp-reveal]');
    if (!items.length) return;

    // Stagger index is scoped per group so sections don't inherit each
    // other's delays and drift to multi-second waits further down the page.
    var groups = {};
    Array.prototype.forEach.call(items, function (el) {
      var g = el.getAttribute('data-hp-group') || 'default';
      groups[g] = (groups[g] || 0);
      el.style.setProperty('--hp-i', Math.min(groups[g], 8));
      groups[g]++;
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );

    Array.prototype.forEach.call(items, function (el) {
      var rect = el.getBoundingClientRect();
      // Anything already on screen at load (the hero) reveals straight away
      // rather than waiting for a scroll that may never come.
      if (rect.top < window.innerHeight) {
        requestAnimationFrame(function () { el.classList.add('is-in'); });
      } else {
        io.observe(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }

  // Theme Editor: re-scan when a section is re-rendered.
  document.addEventListener('shopify:section:load', setup);
})();
